/* eslint-disable import/prefer-default-export */
export const useElements = { // 幻灯片
  widthRatio: 0.398, // 宽度占比 vw
  margin: 0, // 左右 外边距 px
  thumbnailListRatio: 0.432, // 缩略图列表占比 vw
  thumbnailWidthRatio: 0.126, // 缩略图宽度占比 vw
  thumbnailHeightRatio: 0.071, // 缩略图高度占比 vw
}
